(function() {
    "use strict";

    new Swiper(".care-guide__quote-slider", {
        effect: "fade",
        allowTouchMove: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });

    new Swiper(".care-guide__image-slider", {
        allowTouchMove: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });

    //
    // Currently not being used
    //
    // new Swiper(".product--plants-package__slider", {
    //     slidesPerView: 4,
    //     allowTouchMove: true,
    //     navigation: {
    //         nextEl: ".swiper-button-next",
    //         prevEl: ".swiper-button-prev"
    //     }
    // });
})();
